import { GhostButton } from '@/components/Button';
import { backgroundColor, combineCls, padding, textColor, twCls } from '@/style';
import { ComponentProps } from 'react';

export type TimePickerButtonProps = ComponentProps<typeof GhostButton> & {
  hours?: number;
  minutes?: number;
};

export const TimePickerButton = ({
  hours,
  minutes,
  ...rest
}: TimePickerButtonProps): JSX.Element => {
  return (
    <GhostButton
      className={combineCls(
        twCls(backgroundColor('bg-grey-300'), textColor('text-grey-900'), padding('py-0')),
      )}
      {...rest}
    >
      {hours?.toString()?.padStart(2, '0')} : {minutes?.toString()?.padStart(2, '0')}
    </GhostButton>
  );
};
